import { render } from "./DocumentPreSavePreview.vue?vue&type=template&id=5b9169be&scoped=true"
import script from "./DocumentPreSavePreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreSavePreview.vue?vue&type=script&lang=js"

import "./DocumentPreSavePreview.vue?vue&type=style&index=0&id=5b9169be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9169be"]])

export default __exports__